import AddRoundedIcon from "@material-ui/icons/AddRounded";
import styled from "styled-components";

const ThumbnailPlus = styled(AddRoundedIcon)`
  font-size: 80px !important;
  color: ${(p) => p.theme.color.primary};
`;

export default ThumbnailPlus;
